// Keep aligned with ProductImageArchiveLimits.MaxZipSize; covered by contract tests.
export const MAX_IMAGE_ZIP_BYTES = 200 * 1024 * 1024
export const IMAGE_ZIP_SIZE_MESSAGE = 'Размер ZIP-архива превышает максимум 200 MB (200 MiB).'

export function validateImageZipSize(file) {
  if (file.size > MAX_IMAGE_ZIP_BYTES) throw new Error(IMAGE_ZIP_SIZE_MESSAGE)
}
